import { render, staticRenderFns } from "./UnitDashboardBuilderComponent.vue?vue&type=template&id=d0407248&scoped=true&"
import script from "./UnitDashboardBuilderComponent.vue?vue&type=script&lang=js&"
export * from "./UnitDashboardBuilderComponent.vue?vue&type=script&lang=js&"
import style0 from "./UnitDashboardBuilderComponent.vue?vue&type=style&index=0&id=d0407248&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0407248",
  null
  
)

component.options.__file = "UnitDashboardBuilderComponent.vue"
export default component.exports